import { render, staticRenderFns } from "./roomOweFees.vue?vue&type=template&id=c8c8d942&scoped=true"
import script from "./roomOweFees.vue?vue&type=script&lang=js"
export * from "./roomOweFees.vue?vue&type=script&lang=js"
import style0 from "./roomOweFees.vue?vue&type=style&index=0&id=c8c8d942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c8d942",
  null
  
)

export default component.exports